import styled from 'styled-components';

export default interface IconProps {
	color?: string;
	rotation?: number;
	className?: string;
	style?: any;
}

export const StyledG = styled.g`
	fill: ${(props) => props.theme.colors[props.color ?? 'slateBlue']};
`;

export const StyledPath = styled.path`
	fill: ${(props) => props.theme.colors[props.color ?? 'slateBlue']};
`;
